// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"443":"about","525":"articles","631":"contact"}[chunkId] + "-legacy." + {"443":"028e0351","525":"23fdf487","631":"5c5b391b"}[chunkId] + ".js";
};